import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import ContentDialog from '@shared/components/core/dialog/ContentDialog';
import { ContentQuickWrap } from '@shared/components/core/text/ContentTypography';
import { useAlertsStore } from '@shared/hooks/state/AlertsContainer';
import { useOrganizationStore } from '@shared/hooks/state/OrganizationContainer';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

interface ISelectOrganizationUpgradeDialogProps {
    open: boolean;
    onCancel: () => void;
}

export default function SelectOrganizationUpgradeDialog({ open, onCancel }: ISelectOrganizationUpgradeDialogProps) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const memberships = useOrganizationStore((state) => state.memberships);

    const availableMemberships = useMemo(() => {
        return memberships.filter((membership) => membership.canManageBilling || membership.isAdmin);
    }, [memberships]);

    const [memberIndex, setMemberIndex] = useState<number>(0);

    const handleRadioSelectionClick = async (value: number) => {
        setMemberIndex(value);
    };

    const onConfirm = async () => {
        const member = availableMemberships[memberIndex];
        useOrganizationStore.setState({ currentOrgId: member.organizationId });
        navigate(`/org/${member?.organizationId}/billing/redirect/upgrade`);
        onDismiss();
    };

    const onDismiss = () => {
        setMemberIndex(0);
        onCancel();
    };

    if (availableMemberships.length === 0) {
        onDismiss();
        useAlertsStore.getState().showError(t('common:organization.error'));
        return null;
    }

    return (
        <ContentDialog
            title={t('common:organization.expired.dialog.title')}
            description={t('common:organization.expired.dialog.description')}
            open={open}
            onCancel={onDismiss}
            onClose={onDismiss}
            onConfirm={onConfirm}
            confirmButtonText={t('common:upgrade')}>
            <RadioGroup
                name={t('common:organization.titlePlural')}
                onChange={(e) => handleRadioSelectionClick(parseInt(e.target.value))}
                value={memberIndex}>
                <ContentQuickWrap>
                    {availableMemberships.map((membership, i) => (
                        <FormControlLabel
                            key={i}
                            value={i}
                            control={<Radio sx={{ padding: '0 9' }} />}
                            label={membership.organization.name}
                        />
                    ))}
                </ContentQuickWrap>
            </RadioGroup>
        </ContentDialog>
    );
}
